'use client';
import React, { useState, useEffect, useCallback } from 'react';

interface FeaturedArticle {
  id: number;
  label: string;
  title: string;
  excerpt: string;
  date: string;
  image: string;
  alt: string;
  href: string;
}

const featuredArticles: FeaturedArticle[] = [
{
  id: 1,
  label: 'Featured',
  title: 'Brickwell Housing Breaks Ground on Elmwood Senior Residences, Expanding Affordable Living for Ages 62+',
  excerpt:
  "RIVERSIDE, CA, April 18, 2026 — Mayor Linda Torres, the Riverside City Council, and development partners gathered to officially break ground on Elmwood Senior Residences — marking a landmark milestone in the City's commitment to expanding affordable housing for senior residents. Located steps from transit and community services, the 120-unit development will serve low-income seniors aged 62 and older.",
  date: 'April 18, 2026',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_134536bf4-1777272190712.png",
  alt: 'Groundbreaking ceremony for Elmwood Senior Residences with officials and community members holding shovels',
  href: '#media'
},
{
  id: 2,
  label: 'Featured',
  title: 'Brickwell Housing Welcomes New CEO Sarah Mitchell, Reaffirming Commitment to Community-First Development',
  excerpt:
  'Brickwell Housing is proud to announce the appointment of Sarah Mitchell as Chief Executive Officer. Mitchell brings over 20 years of affordable housing development experience and a deep commitment to resident-centered design. Under her leadership, Brickwell will accelerate its mission to create vibrant, sustainable communities across the nation. April 22, 2026',
  date: 'April 22, 2026',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c0007e95-1763295050768.png",
  alt: 'Professional portrait of Sarah Mitchell, new CEO of Brickwell Housing, in a modern office setting',
  href: '#media'
},
{
  id: 3,
  label: 'Featured',
  title: 'Brickwell Housing and City Officials Celebrate Groundbreaking of Harborview Family Townhomes',
  excerpt:
  'New Neighborhood Will Feature 180 Townhomes for Workforce and Affordable Family Housing. LONG BEACH, CA, March 18, 2026 — City officials joined executives of Brickwell Housing for a ceremonial groundbreaking at the Harborview Family Townhomes site, a transformative development that will bring 180 mixed-income townhomes to the Long Beach waterfront district.',
  date: 'March 18, 2026',
  image: "https://images.unsplash.com/photo-1513985225645-68544cda1823",
  alt: 'Aerial view of modern townhome development near waterfront with green spaces and community amenities',
  href: '#media'
}];


export default function MediaCenterHero() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [direction, setDirection] = useState<'left' | 'right'>('right');
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const goToSlide = useCallback(
    (index: number) => {
      if (isAnimating || index === activeIndex) return;
      setDirection(index > activeIndex ? 'right' : 'left');
      setIsAnimating(true);
      setTimeout(() => {
        setActiveIndex(index);
        setIsAnimating(false);
      }, 350);
    },
    [activeIndex, isAnimating]
  );

  useEffect(() => {
    const timer = setInterval(() => {
      const next = (activeIndex + 1) % featuredArticles.length;
      goToSlide(next);
    }, 6000);
    return () => clearInterval(timer);
  }, [activeIndex, goToSlide]);

  const article = featuredArticles[activeIndex];

  return (
    <section
      style={{
        paddingTop: '56px',
        paddingBottom: '56px',
        backgroundColor: '#ffffff',
        overflow: 'hidden',
        marginTop: '80px'
      }}>

      <div
        style={{
          maxWidth: '1280px',
          margin: '0 auto',
          padding: '0 20px'
        }}>

        <div
          style={{
            position: 'relative',
            overflow: 'hidden'
          }}>

          <div
            key={activeIndex}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'stretch',
              minHeight: '500px',
              gap: '0',
              opacity: mounted && isAnimating ? 0 : 1,
              transform:
              mounted && isAnimating ?
              `translateX(${direction === 'right' ? '-30px' : '30px'})` :
              'translateX(0)',
              transition: 'opacity 0.35s ease, transform 0.35s ease'
            }}
            className="featured-slide">

            <div
              style={{
                flex: '0 0 43%',
                maxWidth: '537px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                paddingRight: '48px'
              }}
              className="featured-slide-content">

              <strong
                style={{
                  display: 'block',
                  fontSize: '20px',
                  fontWeight: 400,
                  color: '#6dcff6',
                  marginBottom: '16px',
                  fontFamily: 'Montserrat, sans-serif',
                  textTransform: 'capitalize'
                }}>

                {article.label}
              </strong>
              <h1
                style={{
                  fontSize: 'clamp(22px, 3.2vw, 40px)',
                  fontWeight: 400,
                  color: '#003c82',
                  lineHeight: '1.2',
                  margin: '0 0 12px',
                  fontFamily: 'Montserrat, sans-serif'
                }}>

                <a
                  href={article.href}
                  style={{
                    color: 'inherit',
                    textDecoration: 'none',
                    transition: 'color 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.color = '#6dcff6';
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.color = '#003c82';
                  }}>

                  {article.title}
                </a>
              </h1>
              <div
                style={{
                  fontSize: '16px',
                  color: '#333333',
                  lineHeight: '22px',
                  fontFamily: 'Montserrat, sans-serif',
                  marginTop: '8px'
                }}>

                {article.excerpt}
              </div>
              <a
                href={article.href}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginTop: '28px',
                  color: '#003c82',
                  fontSize: '14px',
                  fontWeight: 600,
                  textDecoration: 'none',
                  fontFamily: 'Montserrat, sans-serif',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLAnchorElement).style.color = '#6dcff6';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLAnchorElement).style.color = '#003c82';
                }}>

                Read More
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
                  <path
                    d="M1 1l6 6-6 6"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round" />

                </svg>
              </a>
            </div>

            <div
              style={{
                flex: '1',
                overflow: 'hidden',
                position: 'relative'
              }}
              className="featured-slide-image">

              <img
                src={article.image}
                alt={article.alt}
                style={{
                  width: '100%',
                  height: '100%',
                  minHeight: '400px',
                  objectFit: 'cover',
                  display: 'block',
                  transition: 'transform 0.6s ease'
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLImageElement).style.transform = 'scale(1.03)';
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLImageElement).style.transform = 'scale(1)';
                }} />

            </div>
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            marginTop: '24px'
          }}>

          {featuredArticles.map((_, idx) =>
          <button
            key={idx}
            onClick={() => goToSlide(idx)}
            aria-label={`Go to slide ${idx + 1}`}
            style={{
              width: idx === activeIndex ? '32px' : '10px',
              height: '10px',
              borderRadius: '5px',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              backgroundColor: idx === activeIndex ? '#003c82' : '#c8d6e8',
              transition: 'all 0.3s ease',
              outline: 'none'
            }} />

          )}
        </div>
      </div>

      <style>{`
        @media (max-width: 1024px) {
          .featured-slide {
            min-height: 400px !important;
          }
          .featured-slide-content {
            padding-right: 28px !important;
          }
        }
        @media (max-width: 768px) {
          .featured-slide {
            flex-direction: column !important;
            min-height: unset !important;
          }
          .featured-slide-content {
            padding-right: 0 !important;
            max-width: 100% !important;
            flex: none !important;
            padding-bottom: 24px;
          }
          .featured-slide-image {
            min-height: 240px !important;
          }
          .featured-slide-image img {
            min-height: 240px !important;
          }
        }
        @media (max-width: 480px) {
          .featured-slide-image {
            min-height: 200px !important;
          }
          .featured-slide-image img {
            min-height: 200px !important;
          }
        }
      `}</style>
    </section>);

}